import React, { useEffect, useState } from 'react';
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ReferenceLine,CartesianGrid, } from 'recharts';
import styles from './GraphBox.module.css'; // Make sure the path is correct
import { useMediaQuery } from '@mui/material';
const GraphBox = () => {

  const isLargeScreen = useMediaQuery('(min-width:568px)');
  const [selected, setSelected] = useState({button: '1', dropdown: 'hk16'});
  const [index, setIndex] = useState({ start: 7, end: -7 , click:0});


//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//         return (
//             <div className="custom-tooltip">
//                 <p className="label">{`Date : ${label}`}</p>
//                 <p className="intro">{`Consumptive : ${payload[0].value}`}</p>
//                 <p className="intro">{`Forecast : ${payload[1].value}`}</p>
//             </div>
//         );
//     }
//     return null;
// };

  const [mergedData, setMergedData] = useState([]);
  const [today, setToday]= useState(new Date().toISOString().split('T')[0]);

  useEffect(() => {
    fetchData();
  }, [selected.button, selected.dropdown]);
  

  const fetchData = async () => {
    let response = await fetch(`${process.env.REACT_APP_API_URL}/d_cons_forc?user=${selected.dropdown}&type=${selected.button}&date=${0}`);
    let fetchedData = await response.json();

   const consumptive = fetchedData
     .filter(dataPoint => new Date(dataPoint.dt) < new Date(today))
     .map(item => ({ date: item.dt, consumptive: item.visitors, forecast: null }));
   
   const forecast = fetchedData
     .filter(dataPoint => new Date(dataPoint.dt) >= new Date(today))
     .map(item => ({ date: item.dt, consumptive: null, forecast: Math.round(item.visitors)}));
   
   setMergedData([...consumptive, ...forecast]);
 

  };

  

  const handleTypeClick = (type) => {
    setSelected(prevState => ({
        ...prevState,
        button: type
    }));
  }

    const handleLocationChange = (value) => {
      setSelected(prevState => ({
          ...prevState,
          dropdown: value
      }));
    }

const displayedData = mergedData.slice(index.start, index.end === 0 ? undefined : index.end);
const handlePreviousWeekClick = () => {
  setIndex(prev => {
    if (prev.click > -1) { 
      return {
        start: prev.start - 7,
        end: prev.end - 7,
        click: prev.click - 1
      };
    }
    return prev;  
  });
};

const handleNextWeekClick = () => {
  setIndex(prev => {
    if (prev.click < 1) { 
      return {
        start: prev.start + 7,
        end: prev.end + 7,
        click: prev.click + 1
      };
    }
    return prev;  
  });
};

console.log('click',index.click)
  const chartMargin = {
    top: 10,
    right: 10,
    left: -25,
    bottom: -10,
  };


  
  const chartWidth = isLargeScreen ? 470 : 290;
  return (
    <div>
<div className={styles.top_button_flex}>
<div className={styles.select_buttons}>
            <button
                className={`${styles.button} ${selected.button === '3' ? styles.button_checked : ''}`}
                onClick={() => handleTypeClick('3')}
            >
                Auto
            </button>
            <button
                className={`${styles.button} ${selected.button === '1' ? styles.button_checked : ''}`}
                onClick={() => handleTypeClick('1')}
            >
                Pedoni
            </button>
        </div>
    <div className={styles.selector}>
        <select className={styles.select1} value={selected.dropdown} onChange={(e) => handleLocationChange(e.target.value)}>
            <option value="hk16">Casalvecchio</option>
            <option value="hk14">Limina</option>
            <option value="hk15">Antillo</option>
        </select>
    </div>
</div>
      <div className={styles.outter_graph}>
      <LineChart className={styles.chart} width={chartWidth} height={220} data={displayedData} margin={chartMargin}>
      
      <Legend wrapperStyle={{left:0}}/>
      
  <XAxis
    dataKey="date"
    stroke="white"
    interval={2} 
    tickFormatter={(tick) => {
        const date = new Date(tick);
        const month = date.getMonth() + 1; // Months are zero-based
        const day = date.getDate();
        return `${day}/${month}`;
    }}
  />
  <YAxis
  //  domain={[0, 4000]}
    stroke="white"
    tickFormatter={(tick) => Math.floor(tick)}
    width={80}
  />
  {/* <Legend /> */}
  <Tooltip 
  content={({ active, payload, label }) => {
    if (!active || !payload) return null;

    const date = new Date(label);
    const formattedDate = date.toLocaleDateString('it-IT');

    return (
      <div className="custom-tooltip" style={{
        backgroundColor: 'rgba(232, 221, 232, 0.8)', 
        border: '1px solid #ccc', 
        padding: '10px', 
        borderRadius: '5px', 
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)'
      }}>
        <p className="label">{formattedDate}</p>
        {payload.map((entry, index) => (
          <p key={`item-${index}`} style={{ color: entry.color }}>
            {`${entry.name}: ${entry.value}`}
          </p>
        ))}
      </div>
    );
  }}
/>
  <Line type="monotone" dataKey="consumptive" stroke="#882A96" name="consuntivo"  dot={true} strokeWidth={2}/>
  <Line type="monotone" dataKey="forecast" stroke="#38962A" name="previsionale"  dot={true} strokeWidth={2}/>
 
    <ReferenceLine x={today} stroke="white" />
  
</LineChart>
      </div>
      <div className={styles.bottom_button_flex}>
      <button className={styles.button_left} onClick={handlePreviousWeekClick}>Sett. precedente</button>
      <button className={styles.button_right} onClick={handleNextWeekClick}>Sett. successiva</button>
      </div>
    </div>
  );
};

export default GraphBox;
